/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Mode_AnswerInputs */

const zh_print_mode_answer = /** @type {(inputs: Print_Mode_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`含答案`)
};

const en_print_mode_answer = /** @type {(inputs: Print_Mode_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With Answers`)
};

const es_print_mode_answer = /** @type {(inputs: Print_Mode_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con respuestas`)
};

/**
* | output |
* | --- |
* | "With Answers" |
*
* @param {Print_Mode_AnswerInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const print_mode_answer = /** @type {((inputs?: Print_Mode_AnswerInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Mode_AnswerInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_print_mode_answer(inputs)
	if (locale === "en") return en_print_mode_answer(inputs)
	return es_print_mode_answer(inputs)
});